import React from "react";
import entries from "lodash/entries";
import ToggleButton from "@mui/material/ToggleButton";

export function ToggleButtonSelect<T extends string>(props: {
  disabled?: boolean;
  value: T;
  options: Record<T, string>;
  onChange(v: T): void;
}) {
  return entries<string>(props.options).map(([value, label]) => (
    <ToggleButton
      key={value}
      value={value}
      color="primary"
      selected={!props.disabled && props.value === value}
      onChange={() => props.onChange(value as T)}
      disabled={props.disabled}
      sx={{ px: 3, py: 1, borderRadius: 8 }}
    >
      {label}
    </ToggleButton>
  ));
}
